// extracted by mini-css-extract-plugin
export default {"DaysFromCreation":"styles_DaysFromCreation__rF+92","orange":"styles_orange__zKNpg","red":"styles_red__iYWEE"};